
export default function () {
    // adapted from github.com/olmokramer/scrollbar-width.js
    // this solution might be overkill, but i believe it should
    // solve for situations where a browser might not have
    // scrollbars when content is shorter than the viewport, but
    // do show scrollbars when content is taller than viewport.
    // a simpler solution is here:
    // tylercipriani.com/blog/2014/07/12/crossbrowser-javascript-scrollbar-detection/
    var scrollbarWidth = null;

    var div1, div2;

    if (document.readyState === 'loading') {
        return null;
    }

    div1 = document.createElement('div');
    div2 = document.createElement('div');
    div1.style.width = div2.style.width = div1.style.height = div2.style.height = '100px';
    div1.style.overflow = 'scroll';
    div2.style.overflow = 'hidden';

    document.body.appendChild(div1);
    document.body.appendChild(div2);
    scrollbarWidth = Math.abs(div1.scrollHeight - div2.scrollHeight);
    document.body.removeChild(div1);
    document.body.removeChild(div2);

    return scrollbarWidth;
}
